import Vue from 'vue'
import gql from 'graphql-tag'
import { Component, Watch } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import { SnackType } from '@/interfaces/snack'
import { Statement } from '@/modules/Statement/interfaces/statement'
import { showErrors, showNotification } from '@/utils/snack'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { deleteStatementById } from '@/modules/Statement/gql/statement.gql'

@Component({
  components: {
    AppDialog,
    AppTextSearch
  }
})
export default class QuoteDialog extends Vue {
  targetStatement: Statement | null = null

  deleteStatementDialog = {
    show: false,
    title: 'Delete Statement',
    disable: false
  }

  async deleteStatement (e: Event, targetStatement: Statement) {
    e.preventDefault()
    e.stopPropagation()
    this.targetStatement = targetStatement
    this.deleteStatementDialog.show = true
  }

  async deleteStatementPost () {
    if (!this.targetStatement) {
      return
    }
    const { id } = this.targetStatement
    this.deleteStatementDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteStatementById,
        variables: {
          statementId: Number(id)
        }
      })

      const res = result.data.deleteStatementById
      if (res) {
        showNotification({
          msg: 'Delete statement successfully',
          type: SnackType.Success
        })
        this.targetStatement = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
